import { Component } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';

import { QuillEditorComponent } from 'ngx-quill';
import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { commentDefaultToolbar, isDeltaBlank } from 'src/app/job/job-activity/comments.utils';
import { selectJobPageChanges } from 'src/app/shared/unsaved-changes-banner/unsaved-changes-banner.selectors';
import { ActionSource } from 'src/app/state/action-sources';
import { LoadingState } from 'src/app/utilities/state.util';

import { NewOpportunityAddInventoryActions } from './new-opportunity-add-inventory.actions';
import { newOpportunityAddInventoryFeature } from './new-opportunity-add-inventory.feature';

@Component({
  selector: 'app-new-opportunity-add-inventory',
  standalone: true,
  imports: [
    FreyaCommonModule,
    QuillEditorComponent,
  ],
  templateUrl: './new-opportunity-add-inventory.component.html',
  styleUrl: './new-opportunity-add-inventory.component.scss'
})
export class NewOpportunityAddInventoryComponent {

  viewModel$ = this.store.select(createSelector({
    inventoryText: newOpportunityAddInventoryFeature.selectInventoryText,
    buttonDisabled: createSelector(
      newOpportunityAddInventoryFeature.selectCallState,
      newOpportunityAddInventoryFeature.selectInventoryText,
      selectJobPageChanges,
      (callState, inventoryText, changes) =>
        callState === LoadingState.MUTATING
        || isDeltaBlank(inventoryText)
        || !changes.some((c) => c.source === ActionSource.ADD_INVENTORY),
    ),
    buttonLabel: createSelector(
      newOpportunityAddInventoryFeature.selectCallState,
      (callState) => callState === LoadingState.MUTATING ? 'Adding...' : 'Add Inventory',
    ),
    buttonIcon: createSelector(
      newOpportunityAddInventoryFeature.selectCallState,
      (callState) => callState === LoadingState.MUTATING ? 'pi pi-spinner pi-spin' : 'pi pi-box',
    ),
  }));

  actions = NewOpportunityAddInventoryActions;

  public modules = {
    toolbar: commentDefaultToolbar,
    keyboard: {
      bindings: {
        submit: {
          key: 'Enter',
          ctrlKey: true,
          handler: (_range, _context) => {
          },
        },
      },
    },
  };

  constructor(public store: Store) {}
}
